// extracted by mini-css-extract-plugin
export default {"clearButton":"styles_clearButton__pRlh1","clearIcon":"styles_clearIcon__sjOtA","spin":"styles_spin__WB46r"};